import { useState } from 'react';

const useOpenClose = ({ initialState = false } = {}) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const toggle = () => {
    return setIsOpen(!isOpen);
  };
  const close = () => {
    return setIsOpen(false);
  };
  const open = () => {
    return setIsOpen(true);
  };

  return { isOpen, toggle, close, open };
};

export default useOpenClose;
